export default "__VITE_ASSET__D_J0ikEY__"